import { ConsultRequest } from '@components/sections/ConsultRequest'

import { config } from './config'

export function GetFreeSection() {
  return <ConsultRequest config={config} inOneLine />
}
